export default __webpack_public_path__ + "static/media/icon-jcb.b7275ddb77bf820946164923aa266681.svg";